import { standardView } from './standard';
import { edrView, xdrView } from './deep-visibility';
import { View } from './types';

export const views: Record<string, View> = {
  [standardView.name]: standardView,
  [edrView.name]: edrView,
  [xdrView.name]: xdrView,
};
